// Badge rarity levels matching BadgeRarity enum from backend
export const BADGE_RARITY = {
  COMMON: 'common',
  UNCOMMON: 'uncommon',
  RARE: 'rare',
  EPIC: 'epic',
  LEGENDARY: 'legendary'
};

// Enhanced rarity ring and shadow styles - BOLDER design
export const RARITY_STYLES = {
  common: 'ring-2 ring-gray-300 dark:ring-gray-600 shadow-sm',
  uncommon: 'ring-2 ring-green-500 dark:ring-green-400 shadow-md shadow-green-100 dark:shadow-green-900/30',
  rare: 'ring-[3px] ring-blue-500 dark:ring-blue-400 shadow-lg shadow-blue-200 dark:shadow-blue-900/30',
  epic: 'ring-[3px] ring-purple-500 dark:ring-purple-400 shadow-xl shadow-purple-300 dark:shadow-purple-900/30 animate-pulse-subtle',
  legendary: 'ring-4 ring-yellow-500 dark:ring-yellow-400 shadow-2xl shadow-yellow-400 dark:shadow-yellow-900/30 animate-badge-glow',
};

// Enhanced background gradients for earned badges
export const RARITY_BG = {
  common: 'bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-800',
  uncommon: 'bg-gradient-to-br from-green-50 to-emerald-100 dark:from-green-900/40 dark:to-emerald-900/40',
  rare: 'bg-gradient-to-br from-blue-50 to-sky-100 dark:from-blue-900/40 dark:to-sky-900/40',
  epic: 'bg-gradient-to-br from-purple-50 to-violet-100 dark:from-purple-900/40 dark:to-violet-900/40',
  legendary: 'bg-gradient-to-br from-yellow-50 via-amber-100 to-yellow-200 dark:from-yellow-900/40 dark:via-amber-900/40 dark:to-yellow-900/40',
};

// Rarity label colors for pills/badges
export const RARITY_LABEL_COLORS = {
  common: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600',
  uncommon: 'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-300 border-green-300 dark:border-green-700',
  rare: 'bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 border-blue-300 dark:border-blue-700',
  epic: 'bg-purple-100 dark:bg-purple-900/50 text-purple-700 dark:text-purple-300 border-purple-300 dark:border-purple-700',
  legendary: 'bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-300 border-yellow-400 dark:border-yellow-600',
};

// Badge category labels
export const CATEGORY_LABELS = {
  vocabulary: 'Vocabulary',
  quiz: 'Quiz',
  streak: 'Streak',
  milestone: 'Milestone',
  attendance: 'Attendance',
  technique: 'Technique',
  tournament: 'Tournament',
};

// Size variants for BadgeCard
export const BADGE_SIZES = {
  sm: {
    container: 'p-2',
    emoji: 'text-2xl',
    name: 'text-xs',
    progressHeight: 'h-1',
    audioButton: 'h-3 w-3',
    trophyIcon: 'h-2 w-2',
    trophyPadding: 'p-0.5',
  },
  md: {
    container: 'p-3',
    emoji: 'text-3xl',
    name: 'text-xs',
    progressHeight: 'h-1.5',
    audioButton: 'h-3.5 w-3.5',
    trophyIcon: 'h-2.5 w-2.5',
    trophyPadding: 'p-0.5',
  },
  lg: {
    container: 'p-4',
    emoji: 'text-4xl',
    name: 'text-sm',
    progressHeight: 'h-2',
    audioButton: 'h-4 w-4',
    trophyIcon: 'h-3 w-3',
    trophyPadding: 'p-1',
  },
};
